export default __webpack_public_path__ + "static/media/empty-box.f1414482.svg";